// Your web app's Firebase configuration
  const firebaseConfig = {
    apiKey: "AIzaSyD8Vj0-9W1sdd7AA6Z9bMBWZ7ci4rIQpRo",
    authDomain: "lavelle-site-form-database.firebaseapp.com",
    databaseURL: "https://lavelle-site-form-database-default-rtdb.firebaseio.com",
    projectId: "lavelle-site-form-database",
    storageBucket: "lavelle-site-form-database.appspot.com",
    messagingSenderId: "360702478261",
    appId: "1:360702478261:web:46c0b3637bb96d67e03bfc"
  };

//initialize firebase
firebase.initializeApp(firebaseConfig);

//reference database
var entryFormDB = firebase.database().ref("entryForm");

document.addEventListener('submit', submitForm);

function submitForm(e){
  
  e.preventDefault();
  
  var name = getElementVal('name');
  var email = getElementVal('email');
  var address = getElementVal('address');
  var phone = getElementVal('phone');
  var age = getElementVal('age');
  console.log(123);
  console.log(name,email,phone);
  saveMessage(name, email, address, phone, age);

  //enable success-alert message
  document.querySelector('.success-alert').style.display = "block";


  //remove success-alert message after 5000 ms (5s)
  setTimeout (() =>{
    document.querySelector('.success-alert').style.display = "none";
    document.querySelector('.text-field').style.display = "block";
    document.querySelector('.button').style.display = "block";
  }, 5000);

  //reset form
  document.getElementById('entryForm').reset();
}

const saveMessage = (name, email, address, phone, age) => {
  var newEntryForm = entryFormDB.push();

  newEntryForm.set({
    name: name,
    email: email,
    address: address,
    phone: phone,
    age: age
  });
};

const getElementVal = (id) => {
  return document.getElementById(id).value;
};


